<div class="file-block" [class.file-block_loading]="isLoading">
  <div [id]="itemId" class="file-block__content">
    @if (currentPlatform !== 'desktop') {
      <div
        class="file-block__content__information"
        [ngClass]="{ 'file-block__content_removed': isRemoved }"
        (click)="openLinkMob()"
      >
        @if (!isLoading) {
          <img class="file-block__preview-mobile" [src]="getFilePreview(true)" />
        }
        <ng-container *ngTemplateOutlet="fileLoader"></ng-container>
        <div class="file-block__text">
          <app-text
            [text]="fileTitle"
            [textType]="TextType.base"
            [textSize]="TextSizes.fileTitle"
          ></app-text>
          @if (fileSubtitle) {
            <app-text
              [text]="fileSubtitle.toString()"
              [textType]="TextType.base"
              [textSize]="TextSizes.fileSubtitle"
            ></app-text>
          }
        </div>
      </div>
    }
    @if (currentPlatform === 'desktop') {
      <a
        #downloadLink
        class="file-block__content__information"
        [class.file-block__content_removed]="isRemoved || type === 'poll'"
        [href]="filePath"
        target="_blank"
      >
        @if (!isLoading) {
          <img class="file-block__preview-web" [src]="getFilePreview(false)" />
        }
        <ng-container *ngTemplateOutlet="fileLoader"></ng-container>
        <div class="file-block__text">
          <app-text
            [text]="fileTitle"
            [textType]="TextType.base"
            [textSize]="TextSizes.fileTitle"
          ></app-text>
          @if (fileSubtitle) {
            <app-text
              [text]="fileSubtitle.toString()"
              [textType]="TextType.base"
              [textSize]="TextSizes.fileSubtitle"
            ></app-text>
          }
        </div>
      </a>
    }
    @if (!postFileView && !isDisabled) {
      <img
        class="delete-button"
        src="assets/images/icons-svg/post-creation/delete-icon.svg"
        (click)="handleDeleteItem(itemId)"
      />
    }
    @if (postFileView) {
      <img
        class="delete-button"
        [class.btn-disabled]="isDisabled"
        [src]="
          'assets/images/icons-svg/' + (inFavouritesList ? 'favourite.svg' : 'not-favourite.svg')
        "
        (click)="handleChangeFavouritesStatus(itemId)"
      />
    }
  </div>
</div>

<ng-template #fileLoader>
  @if (isLoading) {
    <div class="file-block__loader">
      <app-svg icon="files/default"></app-svg>
      <ion-spinner name="circular"></ion-spinner>
    </div>
  }
</ng-template>
